import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Safely extract a string message from an axios error, handling FastAPI
 *  422 validation responses where `detail` is an array of objects. */
export function errMsg(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(", ");
  if (typeof detail === "string") return detail;
  return fallback;
}
